/**
 * The link-code alphabet, shared by the pairing input and its tests.
 *
 * Twenty-seven characters, per design §2.1 as corrected in `tasks.md` at 5.1. Note what is **not**
 * here: `0`, `1`, `2` and `5` are missing as well as `O`, `I`, `L`, `Z` and `S`. The design excludes
 * four confusable *groups*, which means both members of each pair — nine glyphs out of thirty-six,
 * leaving twenty-seven and a keyspace of 27⁶.
 *
 * That matters for the input: there is nothing to fold a mistyped `O` onto, because `0` is not legal
 * either. Filtering is the only correct response, and the code boxes visibly not filling is the
 * feedback. A character that cannot appear in a code cannot be typed into the field.
 */
export const CODE_ALPHABET = "346789ABCDEFGHJKMNPQRTUVWXY";

export const CODE_LENGTH = 6;

/** Upper-cases, drops anything outside the alphabet, and caps the length. */
export function normaliseCode(raw: string): string {
  return raw
    .toUpperCase()
    .split("")
    .filter((character) => CODE_ALPHABET.includes(character))
    .join("")
    .slice(0, CODE_LENGTH);
}
